import React, { useEffect, useState } from "react";
import axios from "../../../Axiosinstance";
import {
  Container,
  Typography,
  Card,
  CardContent,
  Grid,
  Box,
  CircularProgress,
  Snackbar,
  Button,
  TextField,
  AppBar,
  Toolbar,
  CssBaseline,
  Tab, Tabs
} from "@mui/material";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import { styled } from "@mui/system";
import SchoolIcon from '@mui/icons-material/School';
import EventNoteIcon from '@mui/icons-material/EventNote';
import StudentTable from './Registor/SelfStudentTab';
import SelfStudentTable from './Registor/CompanyStudentTable';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import PeopleIcon from '@mui/icons-material/People';
import NotificationsIcon from '@mui/icons-material/Notifications'; // Import the bell icon

import 'bootstrap/dist/css/bootstrap.min.css';

// Styled components
const StyledCard = styled(Card)(({ theme }) => ({
  cursor: "pointer",
  marginBottom: theme.spacing(2),
  transition: "background-color 0.3s",
  "&:hover": {
    backgroundColor: "#e0f7fa",
  },
  boxShadow: "0 3px 6px rgba(0,0,0,0.1)", // Adding shadow for depth
}));

const StyledContainer = styled(Container)(({ theme }) => ({
  marginTop: theme.spacing(4),
  marginBottom: theme.spacing(4),
}));

const CourseList = () => {
  const [courses, setCourses] = useState([]);
  const [currentCourseId, setCurrentCourseId] = useState(null);
  const [currentCourseName, setCurrentCourseName] = useState("");
  const [batchData, setBatchData] = useState([]);
  const [selectedBatchId, setSelectedBatchId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [selectedDate, setSelectedDate] = useState("");
  const [courseDetails, setCourseDetails] = useState(null);
  const [selectedBatchName, setSelectedBatchName] = useState("");
  const [selectedBatchData, setSelectedBatchData] = useState("");
  const [selectedTab, setSelectedTab] = useState(0); // For tab selection


  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  useEffect(() => {
    fetchCourses();
  }, []);

  const fetchCourses = () => {
    setLoading(true);
    axios
      .get("/wsq/course/student-counts")
      .then((response) => {
        setCourses(response.data);
      })
      .catch((error) => {
        console.error("Error fetching course data:", error);
        setError("Failed to fetch course data. Please try again.");
        setSnackbarOpen(true);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const fetchBatchData = async (courseId, date = null) => {
    setLoading(true);
    let apiUrl = `/wsq/batches/course/${courseId}/batches`;

    // Add date parameters if provided
    if (date) {
      const year = new Date(date).getFullYear();
      const month = new Date(date).getMonth() + 1;
      const day = new Date(date).getDate();
      apiUrl += `?year=${year}&month=${month}&day=${day}`;
    }

    // Add language parameter if it exists
    if (searchLanguage.trim()) {
      const languageQuery = `language=${encodeURIComponent(searchLanguage.trim())}`;
      apiUrl += apiUrl.includes('?') ? `&${languageQuery}` : `?${languageQuery}`;
    }

    try {
      const response = await axios.get(apiUrl);
      setBatchData(response.data); // Assuming response data contains the batch information
    } catch (error) {
      console.error("Error fetching batch data:", error);
    } finally {
      setLoading(false);
    }
  };



  const handleCardClick = (courseId, courseName) => {
    setCurrentCourseId(courseId);
    setCurrentCourseName(courseName);
    setSelectedBatchId(null); // Clear selected batch
    fetchBatchData(courseId);
  };

const handleBatchClick = async (batchId, batchName) => {
  // Fetch batch details by batchId
  const response = await axios.get(`/wsq/batches/${batchId}`);
  setSelectedBatchData(response.data); // Set the fetched batch data
  setSelectedBatchId(batchId); // Set the selected batch ID
  setSelectedBatchName(batchName); // Set the selected batch name
};


  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
    setError(null);
  };

  const handleSearchClick = () => {
    if (currentCourseId && selectedDate) {
      fetchBatchData(currentCourseId, selectedDate);
    }
  };

  const handleBackToCourses = () => {
    setCurrentCourseId(null);
    setCurrentCourseName("");
    setBatchData([]);
    setSelectedDate("");
  };

  const handleBackToBatches = () => {
    setSelectedBatchId(null);
  };

  useEffect(() => {
    fetchCourses();
  }, []);

  useEffect(() => {
    if (currentCourseId) {
      fetchCourseDetails(currentCourseId);
    }
  }, [currentCourseId]); // This will run every time currentCourseId changes

  const fetchCourseDetails = (courseId) => {
    setLoading(true);
    axios
      .get(`/wsq/courses/${courseId}`)
      .then((response) => {
        setCourseDetails(response.data);

      })

      .catch((error) => {
        console.error("Error fetching course details:", error);
        setError("Failed to fetch course details. Please try again.");
        setSnackbarOpen(true);
      })
      .finally(() => {
        setLoading(false);
      });
  };



  const [searchLanguage, setSearchLanguage] = useState("");

  // Handle language search input change
  const handleLanguageChange = (e) => {
    setSearchLanguage(e.target.value);
  };

  // Filter batchData based on search input
  const filteredBatchData = batchData.filter(batch =>
    batch.language.toLowerCase().includes(searchLanguage.toLowerCase())
  );




  return (
    <div>
      <CssBaseline />

      {/* App Bar (Header) */}
      <AppBar position="static" sx={{ marginBottom: 4 }}>
        <Toolbar>
          <Typography variant="h6" sx={{ flexGrow: 1 }}>
            Course & Batch Management
          </Typography>
        </Toolbar>
      </AppBar>




      <Container maxWidth="xl">


        <Grid container spacing={2}>

          {/* Left Column: Course List */}
          {!currentCourseId && !selectedBatchId && (
            <Grid item xs={12}>
              <Box
                sx={{
                  paddingRight: 2,
                  paddingBottom: 2,
                  height: "100%",
                  overflowY: "auto",
                }}
              >
                {loading ? (
                  <CircularProgress />
                ) : (
                  <Grid container spacing={3}>
                    {courses.length > 0 ? (
                      courses.map((course, index) => (
                        <Grid item xs={12} sm={6} md={4} lg={4} key={index}>
                          <StyledCard
                            onClick={() => handleCardClick(course.courseId, course.courseName)}
                            sx={{
                              height: "280px",
                              minHeight: "280px",
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "space-between",
                              cursor: "pointer",
                              borderRadius: 3,
                              boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                              position: "relative", // Ensure absolute positioning for icons works
                              backgroundColor: course.batchCount > 0 ? "#e0f7fa" : "transparent", // Greenish background if batchCount > 0
                              "&:hover": {

                                boxShadow: "0 6px 12px rgba(0,0,0,0.2)",
                                backgroundColor: course.batchCount > 0 ? "#fff55b" : "#f1f1f1", // Green on hover for batchCount > 0
                              },
                            }}
                          >
                            {/* Display batch count at the top if more than 0 */}
                            {course.batchCount > 0 && (
                              <Box
                                sx={{
                                  position: "absolute",
                                  top: 10,
                                  left: 10,
                                  backgroundColor: "green",
                                  color: "white",
                                  padding: "5px 10px",
                                  borderRadius: "5px",
                                  fontSize: "14px",
                                  fontWeight: "bold",
                                }}
                              >
                                {course.batchCount} Batches
                              </Box>
                            )}

                            <CardContent sx={{ padding: 3 }}>
                              <br />
                              <Typography variant="h6" gutterBottom>
                                <SchoolIcon sx={{ verticalAlign: "middle", marginRight: 1 }} />
                                {course.courseName}
                              </Typography>
                              <Box sx={{ marginTop: 1 }}>
                                <Typography variant="body2" color="textSecondary" sx={{ display: 'flex', alignItems: 'center' }}>
                                  <AttachMoneyIcon fontSize="small" sx={{ marginRight: 0.5 }} />
                                  Fees: ${course.fees || "N/A"}
                                </Typography>
                                <Typography variant="body2" color="textSecondary" sx={{ display: 'flex', alignItems: 'center', marginTop: 1 }}>
                                  <AccessTimeIcon fontSize="small" sx={{ marginRight: 0.5 }} />
                                  Duration: {course.duration || "N/A"}
                                </Typography>
                                <Typography variant="body2" color="textSecondary" sx={{ display: 'flex', alignItems: 'center', marginTop: 1 }}>
                                  <PeopleIcon fontSize="small" sx={{ marginRight: 0.5 }} />
                                  No of Batches: {course.batchCount || "N/A"}

                                  {/* Conditionally render the bell icon only if batchCount is greater than 0 */}
                                  {course.batchCount > 0 && (
                                    <NotificationsIcon
                                      sx={{
                                        position: "absolute",
                                        top: 10,
                                        right: 10,
                                        color: "red", // Red color for the bell icon
                                        fontSize: "30px",
                                        zIndex: 1,
                                      }}
                                    />
                                  )}
                                </Typography>
                              </Box>
                            </CardContent>
                          </StyledCard>
                        </Grid>
                      ))
                    ) : (
                      <Typography>No courses available.</Typography>
                    )}
                  </Grid>

                )}
              </Box>
            </Grid>
          )}


          {/* Middle Column: Date Filter + Batch List */}
          {currentCourseId && !selectedBatchId && (
            <Grid item xs={12}>
              <Box>
                <Button variant="contained" onClick={handleBackToCourses} sx={{ marginBottom: 2, backgroundColor: '#007bff', '&:hover': { backgroundColor: '#0056b3' } }}>
                  Back to Courses
                </Button>

                <Typography variant="h5" sx={{ fontWeight: 'bold', color: '#333', marginBottom: 3 }}>
                  {currentCourseName}
                </Typography>

                {/* Date Picker and Search Button */}

                {/* Course Details */}
                {currentCourseId && courseDetails && (
                  <Grid container spacing={3} sx={{ marginBottom: 4 }}>
                    {/* First Column */}
                    <Grid item xs={12} sm={6}>
                      <Box sx={{ padding: 2, borderRadius: 2, boxShadow: 2, backgroundColor: '#f7f9fc' }}>
                        <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
                          Course Name:
                        </Typography>
                        <Typography variant="body1" sx={{ marginBottom: 1 }}>
                          {courseDetails.name}
                        </Typography>
                        <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
                          Fees:
                        </Typography>
                        <Typography variant="body1" sx={{ marginBottom: 1 }}>
                          ${courseDetails.fee}
                        </Typography>
                        <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
                          Duration:
                        </Typography>
                        <Typography variant="body1">
                          {courseDetails.courseDuration} weeks
                        </Typography>

                      </Box>
                    </Grid>

                    {/* Second Column */}
                    <Grid item xs={12} sm={6}>
                      <Box sx={{ padding: 2, borderRadius: 2, boxShadow: 2, backgroundColor: '#f7f9fc' }}>
                        <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
                          Languages:
                        </Typography>
                        <Typography variant="body1" sx={{ marginBottom: 1 }}>
                          {courseDetails.languages.join(', ')}
                        </Typography>
                        <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
                          Location:
                        </Typography>
                        <Typography variant="body1" sx={{ marginBottom: 1 }}>
                          {courseDetails.courseLocation}
                        </Typography>
                        <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
                          Assessment Criteria:
                        </Typography>
                        <Typography variant="body1">
                          {courseDetails.assessmentCriteria.map((criteria, index) => (
                            <span key={index}>{criteria.mode} - {criteria.method} </span>
                          ))}
                        </Typography>
                      </Box>
                    </Grid>
                  </Grid>
                )}

                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, marginBottom: 4 }}>
                  <TextField
                    type="date"
                    value={selectedDate}
                    onChange={(e) => setSelectedDate(e.target.value)}
                    sx={{ width: '50%', maxWidth: 200 }}
                    variant="outlined"
                  />

                  <TextField
                    type="text"
                    placeholder="Search by Language"
                    value={searchLanguage}
                    onChange={handleLanguageChange}
                    sx={{ width: '70%', maxWidth: 200 }}
                    variant="outlined"
                  />
                  <Button
                    variant="contained"
                    onClick={handleSearchClick}
                    sx={{
                      width: 180,
                      height: 50,
                      backgroundColor: '#007bff',
                      fontWeight: 'bold',
                      '&:hover': { backgroundColor: '#0056b3' },
                    }}
                  >
                    Search
                  </Button>
                </Box>


                {/* Batch List */}
                {loading ? (
                  <CircularProgress />
                ) : (
                  <Grid container spacing={3} sx={{ marginTop: 2 }}>
                    {batchData.length > 0 ? (
                      batchData.map((batch, index) => (
                        <Grid item xs={12} sm={6} md={4} key={index}>
                          <StyledCard
                            onClick={() => handleBatchClick(batch.id, batch.name)}
                            sx={{
                              height: '100%',
                              cursor: 'pointer',
                              boxShadow: 3,
                              transition: 'transform 0.2s',
                              '&:hover': { transform: 'scale(1.05)' },
                              position: 'relative',
                            }}
                          >
                            <CardContent sx={{ padding: 2, position: 'relative' }}>
                              {/* Notification Indicator */}
                              {batch.heldCount > 0 && (
                                <Box
                                  sx={{
                                    position: 'absolute',
                                    top: 8,
                                    right: 8,
                                    width: 12,
                                    height: 12,
                                    borderRadius: '50%',
                                    backgroundColor: 'red',
                                  }}
                                />
                              )}
                              <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' }}>
                                Batch ID: {batch.name}
                              </Typography>
                              <Typography variant="body2" color="textSecondary" sx={{ marginBottom: 1 }}>
                                <strong>Class Size:</strong> {batch.intakeSize}
                              </Typography>
                              {/* <Typography variant="body2" color="textSecondary" sx={{ marginBottom: 1 }}>
                                <strong>Booked:</strong> 
                                </Typography> */}

                              <Typography variant="body2" color="textSecondary" sx={{ marginBottom: 1 }}>
                                <strong>Seats Available:</strong> {batch.slotLimit}
                              </Typography>
                              <Typography variant="body2" color="textSecondary" sx={{ marginBottom: 1 }}>
                                <strong>Language:</strong> {batch.language}
                              </Typography>


                              <Box sx={{ display: 'flex', alignItems: 'center', marginTop: 1 }}>
                                <EventNoteIcon sx={{ verticalAlign: 'middle', marginRight: 1, color: '#007bff' }} />
                                <Typography variant="body2">
                                  <strong>Dates:</strong>{" "}
                                  {batch.days
                                    .map((day) => {
                                      const date = new Date(day.date);
                                      return date.toLocaleDateString("en-GB"); // 'en-GB' formats the date as dd/mm/yyyy
                                    })
                                    .join(", ")}
                                </Typography>

                              </Box>

                              {/* Status section with counts */}
                              <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: '#007bff', marginTop: 1 }}>
                                Status:
                              </Typography>

                              <Box sx={{ display: 'flex', marginTop: 1, justifyContent: 'space-between' }}>
                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                  <CheckCircleIcon sx={{ color: 'green', marginRight: 1 }} />
                                  <Typography variant="body2" sx={{ fontWeight: 'bold', color: 'green' }}>
                                    <strong>Approved:</strong> {batch?.approvedCount || 0}
                                  </Typography>
                                </Box>

                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                  <CancelIcon sx={{ color: 'red', marginRight: 1 }} />
                                  <Typography variant="body2" sx={{ fontWeight: 'bold', color: 'red' }}>
                                    <strong>Rejected:</strong> {batch?.rejectedCount || 0}
                                  </Typography>
                                </Box>

                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                  <AccessTimeIcon sx={{ color: 'brown', marginRight: 1 }} />
                                  <Typography variant="body2" sx={{ fontWeight: 'bold', color: 'brown' }}>
                                    <strong>Hold:</strong> {batch?.heldCount || 0}
                                  </Typography>
                                </Box>
                              </Box>

                            </CardContent>
                          </StyledCard>
                        </Grid>

                      ))
                    ) : (
                      <Typography>No batches available for this course.</Typography>
                    )}
                  </Grid>
                )}
              </Box>
            </Grid>
          )}



          {/* Right Column: Student List */}
          {selectedBatchId && selectedBatchData && (
  <Grid item xs={12}>
    <Box sx={{ height: '100%', overflowY: 'auto' }}>
      <Button
        variant="contained"
        onClick={handleBackToBatches}
        sx={{ marginBottom: 2 }}
      >
        Back to Batches
      </Button>

      {/* Course and Batch Name */}
      <Typography variant="h5" sx={{ fontWeight: 'bold', color: '#333', marginBottom: 3 }}>
        {currentCourseName}
      </Typography>
      <Typography variant="h5" sx={{ fontWeight: 'bold', color: '#333', marginBottom: 3 }}>
        {selectedBatchName}
      </Typography>

      {/* Batch and Course Details */}
      <Grid container spacing={1} sx={{ marginBottom: 2 }}>
        <Grid item xs={12} sm={6}>
          <Box sx={{ border: '1px solid #ccc', padding: 1, display: 'flex', flexDirection: 'column' }}>
            <Typography variant="subtitle1">Batch Name: {selectedBatchData.name}</Typography>
            <Typography variant="subtitle1">Course Name: {selectedBatchData.course.name}</Typography>
            <Typography variant="subtitle1">Fees: ${selectedBatchData.course.fee}</Typography>
            <Typography variant="subtitle1">Duration: {selectedBatchData.course.courseDuration}</Typography>
            <Typography variant="subtitle1">Intake Size: {selectedBatchData.intakeSize}</Typography>
            <Typography variant="subtitle1">Slot Limit: {selectedBatchData.slotLimit}</Typography>
          </Box>
        </Grid>
        
        <Grid item xs={12} sm={6}>
          <Box sx={{ border: '1px solid #ccc', padding: 1, display: 'flex', flexDirection: 'column' }}>
            <Typography variant="subtitle1">Languages: {selectedBatchData.course.languages.join(', ')}</Typography>
            <Typography variant="subtitle1">Location: {selectedBatchData.course.courseLocation}</Typography>
            <Typography variant="subtitle1">Assessment Criteria: {selectedBatchData.course.assessmentCriteria.map((criteria, index) => (
              <span key={index}>{criteria.mode} - {criteria.method} </span>
            ))}</Typography>
            <Typography variant="subtitle1">Venue: {selectedBatchData.venue.street}, {selectedBatchData.venue.block}, Floor {selectedBatchData.venue.floor}</Typography>
            <Typography variant="subtitle1">Days: {selectedBatchData.days.map(day => (
              <span key={day.id}>{day.date}</span>
            ))}</Typography>
          </Box>
        </Grid>
      </Grid>

      {/* Display Students Tab */}
      <Tabs
        value={selectedTab}
        onChange={handleTabChange}
        centered
        sx={{ maxWidth: "80%", width: "100%", marginBottom: 2 }}
      >
        <Tab label="Company Register Students" />
        <Tab label="Self Register Students" />
      </Tabs>

      <Box sx={{ width: "100%", padding: 2 }}>
        {selectedTab === 0 && <SelfStudentTable batchId={selectedBatchId} />}
        {selectedTab === 1 && <StudentTable batchId={selectedBatchId} />}
      </Box>
    </Box>
  </Grid>
)}



        </Grid>
      </Container>

      {/* Snackbar for Error Messages */}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        message={error}
        action={
          <Button color="inherit" onClick={handleSnackbarClose}>
            Close
          </Button>
        }
      />
    </div>
  );
};

export default CourseList;
